import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import validarpermiso from '../../lib/utils';
import { Button, Form, Input, Modal, message } from "antd";
import { getDirectusClient } from "../../lib/directus";
import Layouts from "../../components/Layouts";
import { readItems, updateItems } from "@directus/sdk";

function CambioSerial() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector((state) => state.permisos);

  const buscarproductofacturado = async (serial, nuevo) => {
    if (!validarpermiso("seriales", "update", permisos)) {
      message.error("No tiene permisos para realizar cambios de seriales");
      return;
    }

    setLoading(true);
    try {
      const directus = await getDirectusClient();
      
      const serialnuevo = await directus.request(
        readItems("seriales", {
          fields: ["*"],
          filter: {
            serial: { _eq: nuevo },
            estado: 1,
          },
        })
      );

      const datos_factura = await directus.request(
        readItems("productos_factura", {
          fields: ["*", "seriales.*"],
          filter: {
            seriales: {
              serial: { _eq: serial },
            },
          },
        })
      );

      console.log(datos_factura);
      if (datos_factura.data.length > 0) {
        console.log(datos_factura.data[0].id);

        const actualizaserial = await directus.request(updateItems("seriales", {
            filter: {
              serial: {
                _eq: serial,
              },
            },
          },
          {
            estado: 1,
          }))

        if (actualizaserial.data.length > 0) {
          console.log("actualizardata");
          if (serialnuevo.data.length > 0) {
            const actualizaserialnuevo = await directus
              .items("seriales")
              .updateOne(
                serialnuevo.data[0].id,

                {
                  estado: 2,
                }
              );

            if (actualizaserialnuevo.id > 0) {
              console.log("actualizar factura");
              const datos_facturam = await directus
                .items("productos_factura")
                .updateOne(datos_factura.data[0].id, {
                  seriales: {
                    create: [],
                    update: [
                      {
                        produtofactura: datos_factura.data[0].id,
                        id: actualizaserialnuevo.id,
                      },
                    ],
                    delete: [actualizaserial.data[0].id],
                  },
                });

              if (datos_facturam.id > 0) {
                form.resetFields();
                Modal.success({ title: "se cambio el serial con exito" });
              }
            } else {
              Modal.error({
                title:
                  "No fue posible actualizar el nuevo serial es probable que no exista ",
              });
            }
          } else {
            Modal.error({
              title:
                "No fue posible actualizar el nuevo serial es probable que no exista ",
            });
          }
        } else {
          Modal.error({
            title:
              "No fue posible actualizar serial anterior es probable que no exista ",
          });
        }
      } else {
        Modal.error({
          title: "No encontramos el serial en ninguna factura existente",
        });
      }

    } catch (error) {
      console.error("Error processing serial change:", error);
      if (error.response?.status === 403 || error.message?.includes('permission')) {
        setHasPermissionError(true);
        message.error("No tiene permisos para realizar esta operación");
      } else {
        message.error("Error al procesar el cambio de serial");
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinish = (values) => {
    if (!validarpermiso("seriales", "update", permisos)) {
      message.error("No tiene permisos para realizar cambios de seriales");
      return;
    }
    buscarproductofacturado(values.serialanterior, values.nuevo);
  };

  return (
    <Layouts>
      {!hasPermissionError ? (
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <h3>
            Bienvenido al módulo de cambio de serial en factura{" "}
            <span style={{ color: "red" }}>
              Por favor verifique los seriales antes de hacer el proceso de cambio
            </span>
          </h3>

          <Form.Item
            label="Serial anterior"
            name="serialanterior"
            rules={[{
              required: true,
              message: "Debe ser un número y no puede estar vacío"
            }]}
          >
            <Input disabled={loading} />
          </Form.Item>

          <Form.Item
            label="Nuevo Serial"
            name="nuevo"
            rules={[{
              required: true,
              message: "Debe ser un número y no puede estar vacío"
            }]}
          >
            <Input disabled={loading} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button 
              type="primary" 
              htmlType="submit"
              loading={loading}
              disabled={hasPermissionError}
            >
              Cambiar Serial
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <h3>No tiene permisos para realizar cambios de seriales</h3>
      )}
    </Layouts>
  );
}

export default CambioSerial;
